import React from 'react'
import { Button, Grid } from 'semantic-ui-react';
import ClosedInitiativeModal from './../../Drive/modals/CompleteInitiative';

class Status extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            setClosedModalStatus: false,
        }

    }

    closedInitiativeClicked = (setClosedModalStatus) => {
        this.setState({ setClosedModalStatus: setClosedModalStatus })
    }


    render() {

        return (
            <div className="w_100">
                <Grid  >
                    <Grid.Row style={{ background: "white", padding: " 10px", margin: " 0 0 10px 0" }}>
                        <Grid.Column width={10}>
                            <div className="pad_10">
                                Once you close an initiative you can not make any changes inside it.
                            </div>
                        </Grid.Column>
                        <Grid.Column width={6}>
                            <div className="pad_10">
                                <Button className="pull-right button-info" onClick={this.closedInitiativeClicked}  >Close Initiative </Button>
                            </div>
                        </Grid.Column>
                    </Grid.Row>

                </Grid>
                <ClosedInitiativeModal open={this.state.setClosedModalStatus}
                    closedInitiativeClicked={this.closedInitiativeClicked}
                    selectedDataById={this.props.selectedDataById}
                    user={this.props.user}
                    selectedOrganisation={this.props.selectedOrganisation}
                    selectedAccount={this.props.selectedAccount}
                />
            </div>
        )
    }
}

export default Status